/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    active: PropTypes.bool,
    disabled: PropTypes.bool,
};

const defaultProps = {
    ...commonDefaultProps,
    active: false,
    disabled: false,
};

const PaginationItem = (props) => {
    const classNames = [
        'c-btn c-btn--square c-btn--tertiary',
        props.active ? 'c-btn c-btn--square c-btn--tertiary c-btn--active' : '',
        props.disabled ? 'c-btn c-btn--square c-btn--disabled' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

PaginationItem.propTypes = propTypes;

PaginationItem.defaultProps = defaultProps;

export default PaginationItem;
